import { Layer } from 'modules/shares/types'

const isGroupLayerWithTints = ({ style, type }: Layer): boolean =>
  !!style?.fills?.filter(fill => fill.isEnabled).length && type === 'group'

const isGroupLayerWithExports = (layer: Layer): boolean =>
  !!layer.exportFormats?.length && layer.type === 'group'

// A layer is considered "styled" if it has borders, fills, shadows, blur,
// innerShadows, an opacity below 1 or a blend mode different than "normal"
const isGroupLayerWithStyles = ({ style, type }: Layer): boolean => {
  const opacity = style?.appearance?.opacity ?? 1

  const isLayerStyled =
    !!Object.keys(style?.borders || {}).length ||
    !!Object.keys(style?.fills || {}).length ||
    !!Object.keys(style?.shadows || {}).length ||
    !!Object.keys(style?.innerShadows || {}).length ||
    !!Object.keys(style?.blur || {}).length ||
    !!(opacity < 1) ||
    style?.appearance?.blendMode !== 'normal'

  return type === 'group' && isLayerStyled
}

export const hasParentGroupWithTints = (
  layers: Record<string, Layer>,
  currentLayer: Layer
): boolean => {
  // Both layer list and current layer with parent are required
  if (!layers || !Object.keys(layers || {}).length || !currentLayer?.parent) {
    return false
  }

  const parentLayer = layers[currentLayer.parent as string]

  return (
    isGroupLayerWithTints(parentLayer) ||
    hasParentGroupWithTints(layers, parentLayer)
  )
}

export const hasParentGroupWithExports = (
  layers: Record<string, Layer>,
  currentLayer: Layer
): boolean => {
  // Both layer list and current layer with parent are required
  if (!layers || !Object.keys(layers || {}).length || !currentLayer?.parent) {
    return false
  }

  const parentLayer = layers[currentLayer.parent as string]

  return (
    isGroupLayerWithExports(parentLayer) ||
    hasParentGroupWithExports(layers, parentLayer)
  )
}

export const hasParentGroupWithStyles = (
  layers: Record<string, Layer>,
  currentLayer: Layer
): boolean => {
  // Both layer list and current layer with parent are required
  if (!layers || !Object.keys(layers || {}).length || !currentLayer?.parent) {
    return false
  }

  const parentLayer = layers[currentLayer.parent as string]

  return (
    isGroupLayerWithStyles(parentLayer) ||
    hasParentGroupWithStyles(layers, parentLayer)
  )
}
